export const NAME = 'chatbot'

export const FETCH_QUESTION_LIST = `${NAME}/FETCH_QUESTION_LIST`
export const FETCH_QUESTION_LIST_SUCCESS = `${NAME}/FETCH_QUESTION_LIST_SUCCESS`

export const FETCH_VALUES_LIST = `${NAME}/FETCH_VALUES_LIST`
export const FETCH_VALUES_LIST_SUCCESS = `${NAME}/FETCH_VALUES_LIST_SUCCESS`
